import {css} from 'emotion'
import { Colors, Brand } from './..'
import URL from './../../static/quizz.jpg'

export const QuizzStyle = css({
  position: 'relative',
  padding: '4rem',
  background: `black url(${URL}) no-repeat center `,
  backgroundSize: 'cover',
  color: 'white',
  height: '100%',
  '@media (min-width: 1024px)': {
    height: 'calc(100vh - 80px)',
  },
  '.quizz': {
    '&-title': {
      textAlign: 'center',
      ...Brand,
      fontWeight: 200,
      lineHeight: 1,
      'svg': {
        fill: 'white',
        marginRight: '1rem',
      }
    },
    '&-up': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
    '&-subtitle': {
      fontSize: '2rem',
    }
  },
  '&.quizz-intro': {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '.quizz-container': {
      margin: '4rem 0',
      
    },
    '.quizz-date': {
      justifyContent: 'center',
      '.quizz-start, .quizz-end': {
        margin: '1rem',
      },
      '.date': {
        color: Colors.mediumGrey
      },
    },
    '.quizz-description': {
      maxWidth: 500,
      margin: '1rem auto',
    },
  },
  'button': {
    maxWidth: 150,
    color: 'white',
  }
})

export const QuizzContainerStyle = (ready) => css({
  '.quizz-title, .quizz-container': {
    opacity: ready ? 1 : 0,
    transition: 'all 400ms ease',
    transform: `translateY(${ready ? 0 : 10}px)`,
  }
})

export const QuizzSlidesStyle = (cover, timer, ready, nextStep, type) => css({
  position: 'relative',
  padding: '4rem',
  background: `black`,
  overflow: 'hidden',
  color: 'white',
  height: '100%',
  '@media (min-width: 1024px)': {
    height: 'calc(100vh - 80px)',
  },
  '&:after': {
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `url(${URL}) no-repeat center left`,
    backgroundSize: 'cover',
    transform: 'translateX(50%)',
    zIndex: 1,
  },
  '.quizz': {
    '&-container': {
      position: 'relative',
      zIndex: 2,
      opacity: ready ? 1 : 0,
      transition: 'opacity 300ms ease',
    },
    '&-picture': {
      maxWidth: '100%',
      flexBasis: '100%',
      height: 300,
      background: `url(${cover}) no-repeat center`,
      backgroundSize: type,

      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/2 * 100%)',
        flexBasis: 'calc(1/2 * 100%)',
        height: 'calc(100vh - 160px - 8rem)',
      }
    },
    '&-question': {
      maxWidth: '100%',
      flexBasis: '100%',

      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/2 * 100%)',
        flexBasis: 'calc(1/2 * 100%)',
        paddingLeft: '4rem',
      }
    },
    '&-pagination': {
      fontSize: '1.125rem',
      fontWeight: 800,
      '&-active': {
        color: Colors.red,
        marginRight: '1rem',
        paddingRight: '1rem',
        borderRight: '1px solid white',
      },
    },
    '&-category': {
      position: 'relative',
      textTransform: 'uppercase',
      fontWeight: 800,
      fontSize: '3rem',
      margin: '2.5rem 0',
      '&:after': {
        content: '""',
        display: 'block',
        width: 50,
        height: 4,
        background: 'white',
        margin: '2.5rem 0',
      }
    },
    '&-title': {
      textTransform: 'uppercase',
      fontWeight: 800,
      fontSize: '1.125rem',
      margin: '2rem 0',
    },
    '&-valid':{
      margin: '2rem 0',
      '.quizz-timer': {
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(100% - 2rem - 150px)',
          flexBasis: 'calc(100% - 2rem - 150px)',
        },
        '.time': {
          fontSize: '0.75rem',
          marginLeft: '1rem',
          fontWeight: 800,
        },
        '.timer': {
          position: 'relative',
          height: 2,
          background: Colors.grey,
          width: 'calc(100% - 40px)',
          maxWidth: 'calc(100% - 40px)',
          flexBasis: 'calc(100% - 40px)',
          '&-progress': {
            background: Colors.red,
            position: 'absolute',
            top: 0,
            left: 0,
            width: `${timer === 0 ? 0 : 100}%`,
            height: '100%',
            transformOrigin: 'center left',
          }
        }
      },
      'button': {
        width: 150,
        color: 'white',
        '@media (min-width: 1024px)': {
          marginLeft: '2rem'
        }
      }
    },
    '&-choices': {
      '.checkbox': {
        margin: '0.5rem 0',
        '&:hover':{
          'input + label': {
            color: 'white',
            '&:after': {
              background: 'white',
            },
            '&:before': {
              borderColor: 'white',
            }
          }
        },
        'svg': {
          fill: 'white',
          verticalAlign: 'middle',
          display: 'none',
          marginLeft: '0.5rem',
        },
        
        'input:checked + label': {
          '&:after': {
            background: 'white',
          },
          '&:before': {
            borderColor: 'white',
          }
        },
      },
      '&:not(.quizz-choices--current)': {
        '.checkbox': {
          '&.bad': {
            'label': {
              color: Colors.red,
              textDecoration: 'line-through',
            }
          }, 
  
          '&.good, &.valid': {
            'svg': {
              display: 'inline'
            },
          },
          '&.good': {
            'label': {
              color: Colors.green,
            },
            'svg': {
              fill: Colors.green,
            }
          },
          '&.valid': {
            'label': {
              color: 'white',
            },
          },
        }
      }
    }
  },
  '.btn-next-question': {
    textAlign: 'right',
    'button': {
      maxWidth: 150
    }
   
  },
  '@keyframes scaleX' : {
    'from': {
      transform: 'scaleX(1)'
    },
    'to': {
      transform: 'scaleX(0)'
    }
  }
}, ready && {
  '.quizz': {
    '&-timer': {
      '.timer-progress': {
        animation: `scaleX ${timer + 0.2}s linear forwards`,
      }
    }
  }
})

export const QuizzFinalStyle = css({
  position: 'relative',
  padding: '4rem',
  background: `black url(${URL}) no-repeat center `,
  backgroundSize: 'cover',
  color: 'white',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontWeight: 800,
  justifyContent: 'center',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 60px)',
  '@media (min-width: 1024px)': {
    height: 'calc(100vh - 80px)',
  },
  '.quizz-final': {
    '&-middle': {
      justifyContent: 'center',
      flexDirection: 'column',
    },
    '&-title':{
      fontSize: '3rem',
    },
    '&-name': {
      fontSize: '2rem',
      margin: '1rem 0',
    },
    '&-score': {
      color: Colors.red,
      fontSize: '4.375rem',
      
    },
    '&-next': {
      position: 'absolute',
      bottom: '4rem',
      left: 0,
      width: '100%',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/quizz.js